import PropTypes from 'prop-types'

const MAX_LENGTH_EAN = 13
const GTIN_KEY = 'GTIN'

const IndicarEAN = ({ value, metadatos, onChangeState, errores }) => {
  const handleChange = (e) => {
    const nuevoValor = e.target.value
    const metadatosActualizados = [...(metadatos || [])]
    const index = metadatosActualizados.findIndex((m) => m.idMetadato === GTIN_KEY)

    if (!nuevoValor) {
      if (index !== -1) metadatosActualizados.splice(index, 1)
    } else if (index !== -1) {
      metadatosActualizados[index] = { idMetadato: GTIN_KEY, valor: nuevoValor }
    } else {
      metadatosActualizados.push({ idMetadato: GTIN_KEY, valor: nuevoValor })
    }
    onChangeState('metadatos', metadatosActualizados)
  }

  const errorMostrar = errores?.ean

  return (
    <>
      <p className="descripcion-cuadro-publicacion">
        Ingresá el código EAN (código de barras) del producto. Debe ser un EAN-8 o EAN-13 válido.
      </p>
      <input
        type="text"
        name="ean"
        value={value}
        onChange={handleChange}
        placeholder="Ej: 1234"
        className={`titulo-publicacion${errorMostrar ? ' error' : ''}`}
        maxLength={MAX_LENGTH_EAN}
        inputMode="numeric"
      />
    </>
  )
}

IndicarEAN.propTypes = {
  value: PropTypes.string.isRequired,
  metadatos: PropTypes.array.isRequired,
  onChangeState: PropTypes.func.isRequired,
  errores: PropTypes.object
}
export default IndicarEAN
